import http from "../http-common";

class AssignTechsTicketsCalendarService {

    // get tech events and display events on calendar (gets events in time range specified by argument values)
    getTechEventsOnCalendar(start_date, end_date, timezone_adjustment_factor) {
        return http.get(`/techAssignment?startDate=${start_date}&endDate=${end_date}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`, {
            withCredentials: true
        });
    }

     // get tech users to fill in searchable drop down 
     getUsers() {
        return http.get(`/techAssignment/users`, {
            withCredentials: true
        });
    }

    getGroupId(id) {
        return http.get(`/techAssignment/getGroupId?id=${id}`, {
            withCredentials: true
        });
    }

    getCountAndTechIds(groupId, findDate, timezoneAdjustmentFactor) {
        return http.get(`/techAssignment/getCountAndTechIds?groupId=${groupId}&findDate=${findDate}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, {
            withCredentials: true
        });
    }

    // Add a new calendar event for tech
    createNewTechEvent(data) {
        return http.post("/techAssignment/addTechEvent", data, {
            withCredentials: true
        });
    }

    // update tech event's start time/end time 
    updateTechEventTime(guid, data) {
        return http.put(`/techAssignment/${guid}/updateTechEventTime`, data, {
            withCredentials: true
        });
    }

    updateTechRecurringEventTimes(id, data) {
        return http.put(`/techAssignment/${id}/updateTechRecurringEventTimes`, data, {
            withCredentials: true
        });
    }

    // update tech event's name/description
    updateTechEventName(guid, data) {
        return http.put(`/techAssignment/${guid}/updateTechEventName`, data, {
            withCredentials: true
        });
    }

    // update recurring tech events' name/description
    updateRecurrTechEventsName(group_id, data) {
        return http.put(`/techAssignment/${group_id}/updateRecurrTechEventsName`, data, {
            withCredentials: true
        });
    }

    // update tech event's date and times (start and end)
    updateTechEventMoved(guid, data) {
        return http.put(`/techAssignment/${guid}/updateTechEventMoved`, data, {
            withCredentials: true
        });
    }

    updateMoveAllRecurEvents(data) {
        return http.put(`/techAssignment/updateMoveAllRecurEvents`, data, {
            withCredentials: true
        });
    }

    // update single tech event into recurring event
    updateSingleEventToRecurringEvents(guid, data) {
        return http.put(`/techAssignment/${guid}/updateSingleEventToRecurringEvents`, data, {
            withCredentials: true
        });
    }

    // delete tech event
    deleteTechEvent(guid) {
        return http.delete(`/techAssignment/${guid}`, {
            withCredentials: true
        });
    }
    
    // delete all recurring events 
    deleteRecurrTechEvents (groupdId, date, timezoneAdjustmentFactor) {
        return http.delete(`/techAssignment/${groupdId}/deleteRecurrTechEvents?dateToCompare=${date}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, {
            withCredentials: true
        });
    }

    // get user id to edit 
    getEditableUserIdRecurrence(event_id, timezoneAdjustmentFactor) {
        return http.get(`/techAssignment/${event_id}/editEvent?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, {
            withCredentials: true
        });
    }

    // add a recurring tech assignment
    addRecurringAssignment(data) {
        return http.post(`/techAssignment/addRecurringAssignment`, data, {
            withCredentials: true
        });
    }

    // get the list of techs as "Last, First MI" for the assigned to dropdown of My Assigned Tickets page (used for "super techs" who can view all techs)
    getTechsForMyTicketsTableDropdown(asker_id) {
        return http.get(`/techAssignment/getTechsForMyTicketsTableDropdown?askerId=${asker_id}`, {
            withCredentials: true
        });
    }
}


export default new AssignTechsTicketsCalendarService();